import { Middleware } from "@reduxjs/toolkit";

import { syncOfferData } from "./offer-reducer";

/**
 * Middleware that enriches syncOfferData actions with userId from the auth state.
 * This allows the reducer to detect self-actions by comparing offeredByUserId with userId.
 */
export const offerMiddleware: Middleware = (store) => (next) => (action) => {
  if (syncOfferData.match(action)) {
    const userId = store.getState().auth?.userId;
    return next({
      ...action,
      payload: { ...action.payload, userId },
    });
  }
  return next(action);
};
